import React, { memo } from "react"
import styled from "@emotion/styled"
import tw from "twin.macro"

import { Icon } from "../Icon/Icon"
import { withModalsPopup } from "./withModalsPopup"

const Container = styled.div`
  ${tw`fixed z-20 inset-0 mt-8-6 md:mt-12-3 flex items-center justify-center transition-all`}
  ${({ active }) => (active ? tw`visible` : tw`invisible`)}
  ${({ active }) => (active ? tw`duration-slow` : ``)}
`

const Bg = styled.div`
  ${tw`fixed bg-transparent inset-0 top-8-6 md:top-12-3 cursor-pointer transition-all`}
  ${({ active }) => (active ? tw`opacity-50` : tw`opacity-0`)}
  ${({ active }) => (active ? tw`duration-slow` : ``)}
`

const ContentWrapper = styled.div`
  ${tw`w-full transition-all absolute z-10`}
  ${({ active }) => (active ? tw`duration-slow translate-y-0` : tw`translate-y-full`)}
  ${({ active }) => (active ? tw`opacity-100 pointer-events-auto` : tw`opacity-0 pointer-events-none`)}
  ${({ noOverflow }) => (!noOverflow ? tw`max-h-8/10-vh overflow-x-hidden overflow-y-auto` : ``)}
  ${({ notify }) => (notify ? tw`max-w-47 px-2-4 lg:px-0` : tw`max-w-100 px-2-4 lg:px-0`)}
`
const Content = styled.div`
  ${tw`relative flex flex-col items-center justify-center bg-lightest border border-dark rounded-1`}
`

const StyledIcon = styled(Icon)`
  ${tw`block pt-1 pr-1`}
`
const Close = styled.button`
  ${tw`absolute top-0 right-0 cursor-pointer hover:opacity-75 focus:outline-none z-50`}
`

const ModalsPopup = withModalsPopup(({ active, children, handleClick, noOverflow, notify }) => {
  return (
    <Container active={active}>
      <Bg active={active} onClick={handleClick} />
      <ContentWrapper className={`hide-scrollbar`} active={active} noOverflow={noOverflow} notify={notify}>
        <Content active={active}>
          <Close onClick={handleClick} title={`close`}>
            <StyledIcon name={`cross`} size={20} />
          </Close>
          {children}
        </Content>
      </ContentWrapper>
    </Container>
  )
})

export default memo(ModalsPopup)
